import { Layout } from 'antd'
import styled from 'styled-components'
const { Header } = Layout

export const HeaderStyle = styled(Header)`
  background: #fff;
  height: 48px;
  line-height: 48px;
  padding: 0 10px;
  .ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected{
    background-color: #fff;
    font-weight: bold;
    color: #1890ff;
    border-bottom: 1px solid #1890ff;
  }
  .ant-menu.ant-menu-dark, .ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark .ant-menu-sub{
    color:#333;
    background: #fff;
  }
  .ant-menu-dark .ant-menu-item, .ant-menu-dark .ant-menu-item-group-title, .ant-menu-dark .ant-menu-item > a, .ant-menu-dark .ant-menu-item > span > a{
    color: rgba(0, 0, 0, 0.65);
  }
  .headerMain{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .dropdownMain{
      padding: 0 10px;
      span{
        margin-left:10px;
      }
    }
  }
`